export var PaymentConditionType;
(function (PaymentConditionType) {
    PaymentConditionType[PaymentConditionType["PDF"] = 0] = "PDF";
    PaymentConditionType[PaymentConditionType["REDIRECT"] = 1] = "REDIRECT";
})(PaymentConditionType || (PaymentConditionType = {}));
